import { useMutation } from "@tanstack/react-query";
import type { WorkflowType } from "../../../zodios/apiDefinitions/workflows";
import { apiClient } from "../../../zodios/client";

export const useStartWorkflow = ({ onSuccess }: { onSuccess: () => void }) =>
  useMutation({
    mutationFn: async (wft: WorkflowType) => await apiClient.startWorkflow({ wft }),
    onSuccess,
  });
